/* globals document */

import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';

const ModalListener = () => {
  const modal = useSelector((state) => state.modal);

  const { currentModal } = modal;

  if (!currentModal) {
    return null;
  }

  return ReactDOM.createPortal(currentModal, document.body);
};

export default ModalListener;
